import { render, staticRenderFns } from "./NotReceivedCampaignsCards.vue?vue&type=template&id=51d64bba"
import script from "./NotReceivedCampaignsCards.vue?vue&type=script&lang=js"
export * from "./NotReceivedCampaignsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports